import { connect } from 'react-redux';

import EmailSubscribeForm from './EmailSubscribeForm';

export function mapStateToProps(state, ownProps) {
  return {
    hasEmail: state.customer ? Boolean(state.customer.email) : false,
    isEUDomains:
      !state.borderfree.isBorderfreeCustomer && state.domain.tld !== '.com',
  };
}

export default connect(mapStateToProps)(EmailSubscribeForm);
